
import { EDListItemButton } from '../../../../../../../../../../BaseComponents/List/Components/EDListItem';
import EDSimpleCheckbox from '../../../../../../../../../../BaseComponents/Checkboxes/SimpleCheckbox/EDSimpleCheckbox';
import EDListItemText from '../../../../../../../../../../BaseComponents/List/Components/EDListItemText';
import { ISumData } from '../../../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import EDTypography from '../../../../../../../../../../BaseComponents/Typography/EDTypography';

interface IProps {
  toggleSelectedSum: (selected: boolean, choise: ISumData) => void;
  sum: ISumData;
  checked: boolean;
  index: number;
  classes?: any;
}

const Styles = (theme: Theme) => ({
  titleMargin: {
    marginLeft: 8,
  },
  flexContainer: {
    display: 'flex',
  },
  paddingLeft: {
    paddingLeft: 8,
  },
  normalText: {
    color: theme.typography.body2.color,
    fontWeight: 300,
  },
});

const SummeringListItem = (props: IProps) => {
  return (
    <EDListItemButton
      onClick={() => props.toggleSelectedSum(props.checked, props.sum)}
      disableVerticalPadding
      disableGutters
    >
      <EDSimpleCheckbox disableRipple checked={props.checked} small />
      <EDListItemText
        bold
        primary={
          <div className={props.classes.flexContainer}>
            <span className={props.classes.normalText}>{props.sum.Namn}</span>
            <EDTypography variant="body2" className={props.classes.titleMargin}>
              {props.index !== -1 ? '(' + (props.index + 1) + ')' : ''}
            </EDTypography>
          </div>
        }
        classes={{ root: props.classes.paddingLeft }}
      />
    </EDListItemButton>
  );
};

export default withStyles(SummeringListItem, Styles);
